import { takeLatest, all, put, fork, call } from 'redux-saga/effects'
import { push } from 'connected-react-router'

import * as actions from '../../actions/actions'

import { postCorporate } from '../../../api/corporateApi'
import {associateCorporateToUser, hasBankAuthorizer} from "../../../api/userApi";

export default function* corporateCreateSaga() {
  yield all([
    fork(watchSaveCorporateCreateRequestRequest),
    fork(watchCreateCorporateIdBankFieldChangeRequest),
    fork(watchCreateCorporateCorporateSenderIdFieldChangeRequest),
    fork(watchCreateCorporateCorporateAutoAcceptFieldChangeRequest),
    fork(watchCreateCorporateCorporateTimeToExpireFieldChangeRequest),
    fork(watchCreateCorporateCorporateWhatsappFieldChangeRequest),
    fork(watchCreateCorporateCorporateDaysToFirstReminderFieldChangeRequest),
    fork(watchCreateCorporateCorporateDaysToSecondReminderFieldChangeRequest),
    fork(watchCreateCorporateCorporateSenderNameFieldChangeRequest),
    fork(watchCreateCorporateEnabledFieldChangeRequest),
    fork(watchCreateCorporateCleanRequest),
    fork(watchCreateCorporateLogoChangeRequest),
    fork(watchCreateCorporatePrimaryColorChangeRequest),
    fork(watchCreateCorporateSecondaryColorChangeRequest),
    fork(watchCreateCorporateCorporateHasBankAuthorizerChangeRequest),
    fork(watchCreateCorporateCorporateHasBankAuthorizerExistsRequest),
  ]);
}

function* watchCreateCorporateLogoChangeRequest() {
  yield takeLatest(
    actions.CREATE_CORPORATE_CORPORATE_LOGO_FILED_CHANGE_REQUEST,
    createCorporateLogoChangeRequest
  )
}

function* createCorporateLogoChangeRequest(logo) {
  yield put({ type: actions.CREATE_CORPORATE_CORPORATE_LOGO_FILED_CHANGE, value: logo.value })
}

function* watchSaveCorporateCreateRequestRequest() {
  yield takeLatest(
    actions.SAVE_CORPORATE_CREATE_REQUEST,
    saveCorporateRequestCreateRequest
  )
}

function* saveCorporateRequestCreateRequest(corporateData) {
  yield put({type: actions.CLEAN_ERROR})
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(postCorporate, corporateData.value.bank,corporateData.value)
    yield put({ type: actions.SAVE_CORPORATE_CREATE_SUCCESS, value: data })
    yield put({ type: actions.SAVE_CORPORATE_CREATE_UPDATE_LIST, value: data.userCorporates })
    yield put(push(`/corporate`))
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
    yield put({ type: actions.CREATE_CORPORATE_CLEAN_REQUEST })
  } catch (error) {
    if(error.response){
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.SAVE_CORPORATE_CREATE_FAILURE, error: error.response })
      yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
    }else if(error.request)
    {
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error.response })
    }
  }
}

function* watchCreateCorporateIdBankFieldChangeRequest() {
  yield takeLatest(
    actions.CREATE_CORPORATE_ID_BANK_FIELD_CHANGE_REQUEST,
    createCorporateIdBankFieldChangeRequest
  )
}

function* createCorporateIdBankFieldChangeRequest(corporateIdBank) {
  if(corporateIdBank.value !== null)
    yield put({ type: actions.CREATE_CORPORATE_ID_BANK_FIELD_CHANGE, value: corporateIdBank.value })
  else
    yield put({ type: actions.CREATE_CORPORATE_ID_BANK_FIELD_CHANGE, value: '' })
}

function* watchCreateCorporateCorporateSenderIdFieldChangeRequest() {
  yield takeLatest(
    actions.CREATE_CORPORATE_CORPORATE_SENDER_ID_FIELD_CHANGE_REQUEST,
    createCorporateCorporateSenderIdFieldChangeRequest
  )
}

function* createCorporateCorporateSenderIdFieldChangeRequest(corporateSenderId) {
  yield put({ type: actions.CREATE_CORPORATE_CORPORATE_SENDER_ID_FIELD_CHANGE, value: corporateSenderId.value })
}


function* watchCreateCorporateCorporateAutoAcceptFieldChangeRequest() {
  yield takeLatest(
      actions.CREATE_CORPORATE_CORPORATE_AUTOACCEPT_FIELD_CHANGE_REQUEST,
      createCorporateCorporateAutoAcceptFieldChangeRequest
  )
}

function* createCorporateCorporateAutoAcceptFieldChangeRequest(autoAccept) {
  if(autoAccept.value !== null)
    yield put({type: actions.CREATE_CORPORATE_CORPORATE_AUTOACCEPT_FIELD_CHANGE, value: autoAccept.value})
  else
    yield put({type: actions.CREATE_CORPORATE_CORPORATE_AUTOACCEPT_FIELD_CHANGE, value: ''})
}


function* watchCreateCorporateCorporateWhatsappFieldChangeRequest() {
  yield takeLatest(
      actions.CREATE_CORPORATE_CORPORATE_WHATSAPP_FIELD_CHANGE_REQUEST,
      createCorporateCorporateWhatsappFieldChangeRequest
  )
}

function* createCorporateCorporateWhatsappFieldChangeRequest(whatsapp) {
  if(whatsapp.value !== null)
    yield put({type: actions.CREATE_CORPORATE_CORPORATE_WHATSAPP_FIELD_CHANGE, value: whatsapp.value})
  else
    yield put({type: actions.CREATE_CORPORATE_CORPORATE_WHATSAPP_FIELD_CHANGE, value: ''})
}

function* watchCreateCorporateCorporateTimeToExpireFieldChangeRequest() {
  yield takeLatest(
      actions.CREATE_CORPORATE_CORPORATE_TIME_TO_EXPIRE_FIELD_CHANGE_REQUEST,
      createCorporateCorporateTimeToExpireFieldChangeRequest
  )
}

function* createCorporateCorporateTimeToExpireFieldChangeRequest(timeToExpire) {
  yield put({ type: actions.CREATE_CORPORATE_CORPORATE_TIME_TO_EXPIRE_FIELD_CHANGE, value: timeToExpire.value })
}

function* watchCreateCorporateCorporateDaysToFirstReminderFieldChangeRequest() {
  yield takeLatest(
      actions.CREATE_CORPORATE_CORPORATE_DAYS_TO_FIRST_REMINDER_FIELD_CHANGE_REQUEST,
      createCorporateCorporateDaysToFirstReminderFieldChangeRequest
  )
}

function* createCorporateCorporateDaysToFirstReminderFieldChangeRequest(daysToFirstReminder) {
  yield put({ type: actions.CREATE_CORPORATE_CORPORATE_DAYS_TO_FIRST_REMINDER_FIELD_CHANGE, value: daysToFirstReminder.value })
}
function* watchCreateCorporateCorporateDaysToSecondReminderFieldChangeRequest() {
  yield takeLatest(
      actions.CREATE_CORPORATE_CORPORATE_DAYS_TO_SECOND_REMINDER_FIELD_CHANGE_REQUEST,
      CreateCorporateCorporateDaysToSecondReminderFieldChangeRequest
  )
}

function* CreateCorporateCorporateDaysToSecondReminderFieldChangeRequest(daysToSecondReminder) {
  yield put({ type: actions.CREATE_CORPORATE_CORPORATE_DAYS_TO_SECOND_REMINDER_FIELD_CHANGE, value: daysToSecondReminder.value })
}

function* watchCreateCorporateCorporateSenderNameFieldChangeRequest() {
  yield takeLatest(
    actions.CREATE_CORPORATE_CORPORATE_SENDER_NAME_FIELD_CHANGE_REQUEST,
    createCorporateCorporateSenderNameFieldChangeRequest
  )
}

function* createCorporateCorporateSenderNameFieldChangeRequest(corporateSenderName) {
  yield put({ type: actions.CREATE_CORPORATE_CORPORATE_SENDER_NAME_FIELD_CHANGE, value: corporateSenderName.value })
}

function* watchCreateCorporateEnabledFieldChangeRequest() {
  yield takeLatest(
    actions.CREATE_CORPORATE_ENABLED_FILED_CHANGE_REQUEST,
    createCorporateEnabledFieldChangeRequest
  )
}

function* createCorporateEnabledFieldChangeRequest(enabled) {
  yield put({ type: actions.CREATE_CORPORATE_ENABLED_FILED_CHANGE, value: enabled.value })
}

function* watchCreateCorporateCleanRequest() {
  yield takeLatest(
    actions.CREATE_CORPORATE_CLEAN_REQUEST,
    createCorporateCleanRequest
  )
}

function* createCorporateCleanRequest() {
  yield put({ type: actions.CREATE_CORPORATE_CLEAN })
}

function* watchCreateCorporatePrimaryColorChangeRequest() {
  yield takeLatest(
    actions.CREATE_CORPORATE_PRIMARY_COLOR_CHANGE_REQUEST,
    createCorporatePrimaryColorChangeRequest
  )
}

function* createCorporatePrimaryColorChangeRequest(value) {
  yield put({ type: actions.CREATE_CORPORATE_PRIMARY_COLOR_CHANGE, value: value.value })
}

function* watchCreateCorporateSecondaryColorChangeRequest() {
  yield takeLatest(
    actions.CREATE_CORPORATE_SECONDARY_COLOR_CHANGE_REQUEST,
    createCorporateSecondaryColorChangeRequest
  )
}

function* createCorporateSecondaryColorChangeRequest(value) {
  yield put({ type: actions.CREATE_CORPORATE_SECONDARY_COLOR_CHANGE, value: value.value })
}
function* watchCreateCorporateCorporateHasBankAuthorizerChangeRequest() {

  yield takeLatest(
      actions.CREATE_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_CHANGE_REQUEST,
      createCorporateCorporateHasBankAuthorizerChangeRequest
  )
}

function* createCorporateCorporateHasBankAuthorizerChangeRequest(value) {

  if(value.value===true){

    yield put({ type: actions.CREATE_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_ENABLE_CHANGE, value: value.value })

  }else if(value.value===false){

    yield put({ type: actions.CREATE_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_DISABLE_CHANGE, value: value.value })
  }

}

function* watchCreateCorporateCorporateHasBankAuthorizerExistsRequest() {
  yield takeLatest(
      actions.CREATE_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_EXISTS_REQUEST,
      createCorporateCorporateHasBankAuthorizerExistsRequest
  )
}

function* createCorporateCorporateHasBankAuthorizerExistsRequest(bankId) {
  yield put({type: actions.CLEAN_ERROR})
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(hasBankAuthorizer, bankId.value)
    if(data===false){
      yield put({ type: actions.CREATE_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_EXISTS,value:true})
    }else if(data===true){
      yield put({ type: actions.CREATE_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_EXISTS,value:false})
    }


    // yield put({ type: actions.SAVE_CORPORATE_CREATE_SUCCESS, value: data })
    // yield put(push(`/corporate`))
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
    // yield put({ type: actions.CREATE_CORPORATE_CLEAN_REQUEST })
  } catch (error) {
    if(error.response){
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.SAVE_CORPORATE_CREATE_FAILURE, error: error.response })
      yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
    }else if(error.request)
    {
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error.response })
    }
  }
}